import { useMutation, useQuery } from 'react-query'
import { notification } from 'antd'
import FileSaver from 'file-saver'
import { searchChats, getChatSession, exportChats } from './chatSearchApi'
import { ChatSearchParams } from './chatSearchModel'

export const useChatSearch = (params: ChatSearchParams | null) => {
  return useQuery({
    queryKey: ['chatSearch', params],
    queryFn: () => searchChats(params!),
    enabled: !!params,
    keepPreviousData: true,
    retry: false,
    onError: () => {
      notification.error({ message: 'Failed to search chat sessions' })
    },
  })
}

export function useExportChatsMutation() {
  return useMutation(
    (params: ChatSearchParams) => exportChats(params),
    {
      onSuccess: (blob) => FileSaver.saveAs(blob, 'chat-export.zip'),
      onError: () => {
        notification.error({ message: 'Export failed', description: 'Could not download chat export.' })
      },
    }
  )
}

export const useChatSession = (sessionId: string | null) => {
  return useQuery({
    queryKey: ['chatSession', sessionId],
    queryFn: () => getChatSession(sessionId!),
    enabled: !!sessionId,
    retry: false,
    onError: () => {
      notification.error({ message: 'Failed to load chat session' })
    },
  })
}
